module.exports = __webpack_public_path__ + "static/w-bg-514b64890472043fb034e55a797a44bb.gif";